module.exports = __webpack_public_path__ + "img/id-verified.0c92ba4c.jpg";